import Toast from './toast'

window.Toast = Toast
